export default {
    home_page_title: "계정정보",
    security_page_title: "안전센터",
    security_setting_page_title: "안전센터",
    security_phone_label: "휴대폰",
    security_email_label: "이메일 주소",
    security_question_label: "안전문제",
    security_unset_text: "미설정",
    security_setted_text: "Set",
    security_question_options: [
        "어머님의 성함은?",
        "배우자의 생일은?",
        "아버님의 성함은?",
        "학생(직장)번호는?",
        "어질적 친구의 이름은?",
        "당신에게 영향제일많이준 사람의 이름은?"
    ],
    password_lost_page_title: "비밀번호 찾기",
    password_reset_page_title: "비밀번호 재설정",
    password_lost_account_placeholder: "찾고싶 계정을 입력하세요",
    empty_lost_account_tips: "계정 입력하세요",
    iscorrect_lost_account_tips: "계정의 존재안합니다",
    password_reset_new_placeholder: "새 비밀번호",
    password_reset_confirm_placeholder: "새 비밀번호를 확인",
    password_verify_page_title: "비밀번호 검증",
    phone_verify_page_title: "전화번호 검증",
    email_verify_page_title: "메일 주소 검증",
    question_verify_page_title: "안전문제 검증",
    phone_reset_page_title: "휴대폰",
    email_reset_page_title: "이메일 주소",
    question_reset_page_title: "안전문제 설정",
    phone_binding_text: "연결된 전화번호는:",
    email_binding_text: "연결된 이메일 주소는:",
    verification_code_text: "인증번호",
    resend_text: "재 발송",
    empty_phone_number_tips: "휴대폰 번호 입력",
    iscorrect_phone_number_tips: "정확한 전화번호를 입력하세요",
    empty_verification_code_tips: "인증번호 입력",
    iscorrect_verification_code_tips: "인증번호가 잘못되었습니다.",
    password_placeholder: "비밀번호",
    empty_password_tips: "비밀번호를 입력하세요",
    iscorrect_password_tips: "정확한 비밀번호를 입력하세요",
    mismatched_rule_password_tips:
        "비밀번호 설정시 특수기호 &,#,띄워쓰기는 입력할 수 없습니다",
    different_confirm_password_tips: "두번의 비밀번호가 같지않습니다",
    empty_email_tips: "이메일 주소를 입력하세요",
    iscorrect_email_tips: "정확한 이메일 주소를 입력하세요",
    answer_placeholder: "정답",
    empty_question_tips: "안전문제를 선택하세요",
    empty_answer_tips: "안전문제를 대답하세요",
    iscorrect_answer_tips: "정답이 아닙니다",
    next_step_text: "다음",
    submit_text: "확인",
    submit_success_tips: "성공",
    submit_error_tips: "확인실패",
    get_data_fail_tips: "네트워크 이상이 있습니다.잠시후 다시 시도하십시오",
    use_other_verification_type_text: "다른 검증방식으로 검증하기",
    custom_support_notice:
        "해당 계정은 비밀번호 되찾기를 설정하지 않았습니다. 컴퓨터를 사용하여 아래 링크를 통해 신청해 주세요. " +
        process.env.VUE_APP_ORIGIN_PROFILE
};
